export const Logo = ({ width = 56 }: { width?: number }) => (
  <img src="/images/logo.svg" alt="Self+ logo" style={{ width }} />
);
